(function(root) {
  'use strict';

  const propertyKeys = ['Lieferzeit', 'Beschaffungsart', '_Beschaffungsart Modus',
    '_Lieferzeit Tage', '_Lieferzeit Basis Tage', '_Lieferzeit Puffer Tage',
    '_Lieferzeit Betriebsferien', '_Lieferzeit Berechnet am'];
  const attributeKeys = ['Gesamtlieferzeit', 'Gesamtlieferzeit Tage',
    'Beschaffungsarten', 'Lieferzeit Berechnet am', 'Lieferzeit Datenversion'];

  function withoutKeys(values, keys) {
    const copy = Object.assign({}, values || {});
    keys.forEach(key => { delete copy[key]; });
    return copy;
  }

  function procurement(mode, fallback) {
    return ({ sample: 'Musterversand', shippingonly: 'Lagerware', workshop: 'Bearbeitung in der Werkstatt',
      production: 'Anfertigungsware', procurement: 'Bestellware' })[String(mode).toLowerCase()] || fallback || 'Auf Anfrage';
  }

  // LPO can restore bundle-component properties from this second snapshot.
  function syncLpoDeliveryProperties(properties) {
    const copy = Object.assign({}, properties);
    if (!copy._cl_options_json) return copy;
    let text = copy._cl_options_json;
    let nested;
    for (let depth = 0; depth < 11; depth++) {
      try { nested = JSON.parse(text); break; } catch (_) {
        const decoded = String(text).replace(/&quot;|&#34;|&#x22;/gi, '"')
          .replace(/&apos;|&#39;|&#x27;/gi, "'").replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        if (decoded === text) break;
        text = decoded;
      }
    }
    if (!nested || typeof nested !== 'object' || Array.isArray(nested)) {
      throw new Error('LPO-Konfigurationsdaten konnten nicht gelesen werden. Bitte Warenkorb pruefen.');
    }
    let changed = false;
    propertyKeys.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(copy, key)) {
        if (nested[key] !== copy[key]) { nested[key] = copy[key]; changed = true; }
      } else if (Object.prototype.hasOwnProperty.call(nested, key)) {
        delete nested[key]; changed = true;
      }
    });
    if (changed) copy._cl_options_json = JSON.stringify(nested);
    return copy;
  }

  function weekNumberFromDate(iso) {
    const day = new Date(iso + 'T00:00:00Z');
    if (!Number.isFinite(day.getTime())) throw new Error('Invalid delivery date');
    day.setUTCDate(day.getUTCDate() - (day.getUTCDay() + 6) % 7);
    return day.getTime() / 604800000;
  }

  // Express the existing delivery calendar window as weeks from the calculation week.
  function relativeWindow(delivery, today) {
    const reference = weekNumberFromDate(today);
    const min = Math.max(1, Math.round(weekNumberFromDate(delivery.deliveryWeekStart) - reference));
    const max = Math.max(min, Math.round(weekNumberFromDate(delivery.deliveryWeekEnd) - reference));
    return { minWeeks: min, maxWeeks: max,
      text: 'Voraussichtliche Lieferzeit: ca. ' + (min === max ? min : min + '-' + max) +
        (max === 1 ? ' Woche' : ' Wochen') + ' ab Bestellung' };
  }

  function createSharedCart(cart, lines, calculate, today) {
    const byKey = new Map(lines.map(line => [line.key, line]));
    const summaries = [];
    const items = cart.items.map(item => {
      const line = byKey.get(item.key);
      const known = line && line.mode !== 'unknown' && Number.isFinite(Number(line.baseDays)) && Number.isFinite(Number(line.bufferDays));
      const delivery = known && line.mode === 'sample' ?
        { minWeeks: 0, maxWeeks: 0, minBusinessDays: 1, maxBusinessDays: 3, text: 'Lieferzeit: 1–3 Werktage' } : known ? relativeWindow(calculate(line.baseDays, line.bufferDays, line.betriebsferien), today) :
        { minWeeks: null, maxWeeks: null, text: 'Lieferzeit auf Anfrage' };
      const status = procurement(line && line.mode, line && line.status);
      summaries.push(Object.assign({ mode: line && line.mode, procurement: status }, delivery));
      return Object.assign({}, item, {
        properties: syncLpoDeliveryProperties(Object.assign(withoutKeys(item.properties, propertyKeys), {
          Lieferzeit: delivery.text, Beschaffungsart: status
        }))
      });
    });
    const allKnown = summaries.length > 0 && summaries.every(line => line.maxWeeks !== null);
    const min = allKnown ? Math.max(...summaries.map(line => line.minWeeks)) : null;
    const max = allKnown ? Math.max(...summaries.map(line => line.maxWeeks)) : null;
    let text = allKnown ? 'Voraussichtliche Lieferzeit: ca. ' + (min === max ? min : min + '-' + max) +
      (max === 1 ? ' Woche' : ' Wochen') + ' ab Bestellung' : 'Gesamtlieferzeit auf Anfrage';
    const samples = summaries.filter(line => line.mode === 'sample');
    if (samples.length === summaries.length && samples.length) text = 'Lieferzeit: 1–3 Werktage';
    else if (samples.length) text = 'Muster: 1–3 Werktage (separater Versand). Weitere Artikel: ' + text;
    const statuses = [...new Set(summaries.map(line => line.procurement))].join(', ');
    return Object.assign({}, cart, {
      items,
      delivery_schema: 2,
      attributes: Object.assign(withoutKeys(cart.attributes, attributeKeys), {
        Gesamtlieferzeit: text, Beschaffungsarten: statuses, 'Lieferzeit Datenversion': '2'
      }),
      delivery: { version: 2, basis: samples.length === summaries.length && samples.length ? 'business_days' : 'calendar_weeks_from_order_week', minWeeks: min, maxWeeks: max,
        text, procurement: statuses }
    });
  }

  const api = { propertyKeys, attributeKeys, procurement, relativeWindow, createSharedCart, syncLpoDeliveryProperties,
    stripProperties: values => withoutKeys(values, propertyKeys),
    stripAttributes: values => withoutKeys(values, attributeKeys) };
  root.MontarioDeliverySnapshot = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
